<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { formatDate } from 'utils/dateutils';
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import AdvInvoiceApplicationBaseForm from '@/views/billing/advertiser/forms/AdvInvoiceApplicationBaseForm.vue';
  import { getAdvInvoiceAppList } from 'api/billing/advertiser/advInvoiceApplicationAPI';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { refreshDownloadUrl } from 'api/s3';
  import AttachmentPopoverTable from '@/components/common/AttachmentPopoverTable.vue';

  export default {
    name: 'AdvInvoiceApplication',
    components: {
      AttachmentPopoverTable,
      AdvInvoiceApplicationBaseForm,
      GroupSelect,
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, financeInfoMixins, billingEnumMixins],
    data() {
      return {
        dialogVisible: false,
        dialogType: 'new',
        auditStatus: null,
        total: 0,
        listLoading: false,
        refreshDownloadUrlLoading: false,
        dataList: [],
        filter: {
          page: 1,
          pageSize: 10,
          advCompanyPlatform: null,
          advEntity: null,
          advInvoiceAppNumber: null,
          advIdList: null,
          advertiserNameList: null,
          sendEmail: null,
          auditStatus: null,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
        },
      };
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          this.filter.sortItems = [];
          this.handleSearch(1);
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleCreate() {
        this.dialogType = 'new';
        this.dialogVisible = true;
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAdvInvoiceAppList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
              this.$refs.tableRef.doLayout();
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
      sourceDetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/source/detail',
          query: {
            sourceId: row.advId,
          },
        });
        window.open(href, '_blank');
      },
      handleApprovalForm(dialogType, auditStatus) {
        this.dialogType = dialogType;
        this.auditStatus = auditStatus;
        this.dialogVisible = true;
      },
      async handleRefreshDownloadLink(row) {
        this.refreshDownloadUrlLoading = true;
        await refreshDownloadUrl({ relatedNumber: row.advInvoiceAppNumber })
          .then(() => {
            this.$message.success('刷新下载链接成功');
            this.handleSearch(1);
          })
          .catch(() => {
            this.$message.warning('刷新下载链接失败,请稍后再试');
          })
          .finally(() => {
            this.refreshDownloadUrlLoading = false;
          });
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Adv Invoice Application '">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="220px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            :clearable="false"
            value-format="yyyy-MM"
            type="monthrange"
            align="right"
            style="width: 260px"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Adv Invoice Application Number">
          <el-input v-model="filter.advInvoiceAppNumber" />
        </el-form-item>
        <el-form-item label="AdvertiserId">
          <group-select
            v-model="filter.advIdList"
            :data-source="sourcesList"
            multiple
            :loading="sourceLoading"
            clearable
            reserve-keyword
            filterable
            placeholder="please select"
          />
        </el-form-item>
        <el-form-item label="Company Platform">
          <el-select
            v-model="filter.advCompanyPlatform"
            filterable
            clearable
            placeholder="please select"
            @change="handleCompanyPlatformChange(filter.advCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Entity">
          <el-select
            v-model="filter.advEntity"
            ref="companyEntityOptions"
            filterable
            clearable
            placeholder="please select"
          >
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Application Status">
          <el-select v-model="filter.auditStatus" filterable clearable placeholder="please select">
            <el-option
              v-for="item in advInvoiceAppAuditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Send Email">
          <el-input v-model="filter.sendEmail"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">Create</el-button>
      <el-button type="success" @click="handleApprovalForm('status', 'APPROVED')"
        >Approve</el-button
      >
      <el-button type="warning" @click="handleApprovalForm('status', 'REJECTED')"
        >UnApprove</el-button
      >
      <el-button type="primary" @click="handleApprovalForm('status', 'EMAIL_SENT')">Sent</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        stripe
        fit
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          sortable="custom"
          key="recordDate"
        />
        <el-table-column
          label="Application Number"
          prop="advInvoiceAppNumber"
          align="center"
          width="220"
          key="advInvoiceAppNumber"
        />
        <el-table-column label="Adv ID" prop="advId" align="center" width="140" key="advId">
          <template slot-scope="scope">
            <span class="cor337ab7" @click="sourceDetailClick(scope.row)">{{
              scope.row.advId
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Adv Name" prop="advName" align="center" width="140" key="advName" />
        <el-table-column
          label="Company Platform"
          prop="advCompanyPlatform"
          align="center"
          width="170"
          key="advCompanyPlatform"
        />
        <el-table-column
          label="Adv Billing Info"
          prop="advEntity"
          align="center"
          width="180"
          show-overflow-tooltip
          key="advEntity"
        >
          <template #default="scope">
            <el-popover trigger="hover">
              <el-descriptions :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Company Name En
                  </template>
                  {{ scope.row.advCompanyInfo.companyNameEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address
                  </template>
                  {{ scope.row.advCompanyInfo.companyAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address En
                  </template>
                  {{ scope.row.advCompanyInfo.companyAddressEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Postal Code
                  </template>
                  {{ scope.row.advCompanyInfo.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Phone
                  </template>
                  {{ scope.row.advCompanyInfo.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Brn
                  </template>
                  {{ scope.row.advCompanyInfo.brn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Tin
                  </template>
                  {{ scope.row.advCompanyInfo.tin }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button type="text" slot="reference">{{ scope.row.advEntity }} </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Conversion"
          prop="advConversion"
          align="center"
          width="140"
          key="advConversion"
        />
        <el-table-column
          label="Adv Revenue"
          prop="advRevenue"
          align="center"
          width="140"
          key="advRevenue"
        />
        <el-table-column
          label="Adv Deduction Amount"
          prop="advDeductionAmount"
          align="center"
          width="180"
          key="advDeductionAmount"
        />
        <el-table-column
          label="Adv Cover Amount"
          prop="advCoverAmount"
          align="center"
          width="170"
          key="advCoverAmount"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          prop="advConfirmedAmount"
          align="center"
          width="220"
          key="advConfirmedAmount"
        />
        <el-table-column
          label="Send Email"
          prop="sendEmail"
          align="center"
          width="220"
          show-overflow-tooltip
          key="sendEmail"
        />
        <el-table-column label="Invoice Files" align="center" width="170">
          <template #default="scope">
            <attachment-popover-table
              @refresh-list="handleSearch"
              :file-list="scope.row.fileList"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Application Status"
          prop="auditStatus"
          align="center"
          width="180"
          fixed="right"
          key="auditStatus"
        >
          <template #default="scope">
            {{ getEnumLabel(advInvoiceAppAuditStatusList, scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Remark"
          prop="remark"
          :show-overflow-tooltip="true"
          align="center"
          key="remark"
          width="220"
        />
        <el-table-column
          label="Audit Remark"
          prop="auditRemark"
          :show-overflow-tooltip="true"
          align="center"
          key="auditRemark"
          width="220"
        />
        <el-table-column
          label="Create Time"
          prop="createTime"
          align="center"
          key="createTime"
          width="160"
        />
        <el-table-column
          label="Create By"
          prop="createBy"
          align="center"
          key="createBy"
          width="160"
        />
        <el-table-column
          label="Update Time"
          prop="updateTime"
          align="center"
          key="updateTime"
          width="160"
        />
        <el-table-column
          label="Update By"
          prop="updateBy"
          align="center"
          key="updateBy"
          width="160"
        />
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
    <template #dialog>
      <adv-invoice-application-base-form
        :dialogVisible.sync="dialogVisible"
        :dialog-type="dialogType"
        :audit-status="auditStatus"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
